'use strict';

import jQuery from 'jquery';
import postItemTemplate from './views/postItem.hbs';
import animateAppend from './../../../vendor/jquery.animate-auto-height.0.0.1';
import PostCollection from './PostCollection';

/**
 * ShowPage
 *
 * JavaScript functions for the show page
 */
var BlogPage = (function($, window) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Give this module a name for state management
      privateNS.name = 'blog';

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the window
      privateNS.$window = $(window);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      privateNS.$postList = privateNS.$container.find('.paginated').find('.related-items');

      privateNS.$postList = privateNS.$container.find('.paginated').find('.related-items');

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Handles the user interaction of clicking on a load more posts link
     * on a show page. This extracts the request information needed to
     * load posts from the clicked link, and registers a callback to
     * update the UI and update the clicked link with new load parameters
     * after the posts have been retrieved
     *
     * @param {Event} event The triggering click event
     */
    privateNS.onLoadMorePosts = function(event) {

      // Cancel the click event
      event.preventDefault();

      // Find the element that the user activated
      var $target = $(event.target);

      // If this element is already loading content, cancel the new
      // request and immediately exit
      if ($target.attr('is-loading') === 'true') {
        return false;
      }

      // Place the target in to loading mode so that multiple requests
      // do not get made for the same assets
      $target.attr('is-loading', true);

      // Extract the data used to generate the load query
      var postOffset = parseInt($target.attr('data-post-offset')) || 0,
        postLimit = parseInt($target.attr('data-post-limit')) || 0,
        category = $target.attr('data-category-id') || 0,
        property = $target.attr('data-property-id') || 0;

      // Create a new collection to handle the posts from the server
      var postsToAdd = new PostCollection();

      // Posts post from the server based on the load more
      // that was clicked
      postsToAdd.
      fetch(postOffset, postLimit, category, property).
      then(function outputPosts(collection){

        // Find the post row that this link was in, then find the
        // post list in that row
        var $postContentRow = $target.parents('.related-posts-row'),
          $postItemList = $postContentRow.find('.related-items');

        var newPostItems = collection.map(function renderPostItem(post) {

          return postItemTemplate(post.getContent());
        });

        // If this a non-mobile device then perform an animated height scaling
        // append on the post list
        if ($.browser.mobile !== true) {

          privateNS.$postList.on(
            'endautoheightanimate',
            function updateTransitionDuration() {

              // Extract the transition duration css property from the list,
              // double it, and then save it back to the element
              privateNS.$postList.css({
                transitionDuration: (parseFloat(
                  privateNS.$postList.
                  css('transition-duration').
                  replace(/[^\d\.]/, ''),
                  10
                ) * 2) + 's'
              });

              // Stop listening for the appending animation event
              privateNS.$postList.off(
                'endautoheightanimate',
                updateTransitionDuration
              );
            }
          );

          // Append the created post items to the post list
          privateNS.$postList.animateAppend(newPostItems.toArray().join(''));
        } else {

          // Otherwise for mobile devices to a traditional append
          privateNS.$postList.append(newPostItems.toArray().join(''));
        }

        // Check to see if the number of results retrieved was less then the limit requested
        if (collection.length() < postLimit) {

          // Add the end class to the final post element so that it aligns
          // properly to the left in the case of posts that are not a multiple
          // of the display column count
          $postItemList.children().last().addClass('end');

          // If it was then remove the loading element, it is no longer needed
          $target.parents('.call-to-action-row').remove();
        } else {

          // If there is still more content to retrieve, update the offsets and
          // limits for this block
          $target.attr({
            'data-post-offset': postOffset + postLimit,
            'data-post-limit': postLimit * 2
          });
        }

        // Now that all posts loading has been completed, turn off the loading
        // property so that the element becomes interactable again
        $target.attr('is-loading', false);

        // Blur the load more target to remove focus styling
        $target.blur();
      });
    };

    privateNS.filterPosts = function(event) {

      // Cancel the click event
      event.preventDefault();

      // Find the element that the user activated
      var $target = $(event.target);

      // Redirect to category page
      window.location = $target.find('option:selected').val();
    };


    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function attachHandlers() {

      // Attach the load more posts handlers
      privateNS.$container.on(
        'click',
        '.loadmore-posts',
        privateNS.onLoadMorePosts
      );

      // Attach the load more posts handlers
      privateNS.$container.on(
        'change',
        '#category-filter',
        privateNS.filterPosts
      );
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery, window);

export default BlogPage